import { render } from "./EditLabSample.vue?vue&type=template&id=70c18e91&scoped=true"
import script from "./EditLabSample.vue?vue&type=script&lang=js"
export * from "./EditLabSample.vue?vue&type=script&lang=js"

import "./EditLabSample.vue?vue&type=style&index=0&id=70c18e91&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c18e91"]])

export default __exports__